import { useEffect, useRef, useState } from "react";
import useAxios from '../../../hooks/useAxios';

const PaintPrice = () => {
    const { AxiosPrivate } = useAxios();
    const [prices, setPrices] = useState([]);
    const [reload, setReload] = useState(false);
    const update = useRef(null);

    const [formData, setFormData] = useState({});

    useEffect(() => {
        const get = async () => {
            try {
                const res = await AxiosPrivate.get('painting/painting-price');
                const data = res.data.data;
                data.reverse();
                setPrices(data);

                const initial = {};
                data.forEach(item => {
                    initial[item.id] = item.value;
                });
                setFormData(initial);

                const latestUpdate = data[0]?.updated_at ?? null;
                if (latestUpdate) {
                    update.current.innerText = `ویرایش: ${new Date(latestUpdate).toLocaleString('fa-IR')}`;
                }
            } catch (err) {
                alert(err.response?.data.message || "خطا در دریافت اطلاعات");
            }
        };
        get();
    }, [reload]);

    const handleInputChange = (id, value) => {
        setFormData(prev => ({
            ...prev,
            [id]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const requests = Object.entries(formData).map(([id, value]) =>
            AxiosPrivate.put('painting/update-price', { id, value })
        );

        try {
            await Promise.all(requests);
            alert("قیمت‌ها با موفقیت ویرایش شدند");
            setReload(prev => !prev);
        } catch (err) {
            alert(err.response?.data.message || "خطا در به‌روزرسانی قیمت‌ها");
        }
    };

    return (
        <div className="p-2">
            <form className="flex gap-6 flex-col items-start" onSubmit={handleSubmit}>
                {prices.map(item => (
                    <div key={item.id} className="flex items-center gap-4">
                        <div className="relative">
                            <input
                                type="number"
                                id={item.id}
                                value={formData[item.id] || ""}
                                onChange={(e) => handleInputChange(item.id, e.target.value)}
                                className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border appearance-none dark:text-white focus:outline-none focus:ring-0 peer"
                                placeholder=""
                            />
                            <label
                                htmlFor={item.id}
                                className="absolute text-nowrap rounded-lg text-sm duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
                            >
                            {item.name}
                            </label>
                        </div>
                        <span>تومان</span>
                    </div>
                ))}

                <div className="w-full flex sm:items-center items-start gap-4 sm:text-base text-sm sm:flex-row flex-col">
                    <p ref={update}></p>
                </div>

                <button
                    type="submit"
                    className="text-white me-3 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:outline-none shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                    ویرایش
                </button>
            </form>
        </div>
    );
};

export default PaintPrice;